/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from 'react';
import { TableProps } from 'antd';
import * as S from './Table.styles';
import './Table.less';

/** "Show 50/100/200 entries", as asked for. */
export const PAGE_SIZE_OPTIONS = ['50', '100', '200'];
export const DEFAULT_PAGE_SIZE = 50;

// TODO make generic!
export const Table: React.FC<TableProps<any>> = ({ pagination, ...props }) => {
  // Defined here rather than per page so every admin table offers the same
  // page sizes. Caller options win, so the server-paginated pages (Users,
  // Shopify Orders) can still drive `current`/`total`/`onChange` themselves.
  const merged = useMemo(
    () =>
      pagination === false
        ? (false as const)
        : {
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            defaultPageSize: DEFAULT_PAGE_SIZE,
            showTotal: (total: number) => `${total.toLocaleString()} total`,
            ...(pagination || {}),
          },
    [pagination],
  );

  return <S.Table {...props} pagination={merged} />;
};
